var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditForm',{ref:"dynamicForm",attrs:{"formName":_vm.formName,"actionBase":'rm_plan',"idFieldName":'routine_plan_id',"moduleName":'Planning',"itemId":_vm.itemId,"fields":_vm.fields,"validations":_vm.validations},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }